// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.side-screen {
  display: flex;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.side-screen-bg {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.side-screen-content {
  display: flex;
  flex-direction: column;
  margin-left: auto;
  width: 427px;
  height: 100%;
  background: #fafafa;
  position: relative;
}

.side-screen-header {
  position: relative;
  padding: 20px;
  background: white;
  max-height: 50vh;
}
.side-screen-header .side-screen-action {
  position: absolute;
  right: 0;
  top: 0;
}
.side-screen-header .side-screen-action__close {
  padding: 25px;
  cursor: pointer;
}
.side-screen-header__label {
  width: 70px;
  text-align: center;
}
.side-screen-header__head {
  margin-top: 15px;
  display: flex;
  align-items: center;
}
.side-screen-header__text {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 32px;
  color: #333333;
  margin-left: 10px;
}

.side-screen-body {
  padding-top: 30px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.side-screen-body__footer {
  display: flex;
  margin-top: 30px;
}
.side-screen-body__footer__image {
  border-radius: 50%;
  height: 24px;
  width: 24px;
  object-fit: cover;
}
.side-screen-body__footer__profile-name {
  margin-left: 5px;
  margin-right: 5px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #868686;
}
.side-screen-body__footer__vertical {
  margin-left: 5px;
  margin-right: 5px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #e9e9e9;
}
.side-screen-body__footer__date {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #999999;
}
.side-screen-body .imgList {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
}
.side-screen-body .imgList img {
  border-radius: 6px;
}

.side-screen-comments {
  padding: 20px;
  margin-top: 15px;
  background: white;
}
.side-screen-comments__border {
  border: 1px solid #333333;
  border-radius: 8px;
  padding: 15px;
}
.side-screen-comments__scroll {
  flex: 1 1;
  overflow-y: auto;
}
.side-screen-comments__head {
  display: flex;
}
.side-screen-comments__head__profileImage {
  border-radius: 50%;
  height: 42px;
  width: 42px;
  object-fit: cover;
}
.side-screen-comments__head__head {
  flex: 1 1;
  margin-left: 15px;
}
.side-screen-comments__head__text {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  display: flex;
  align-items: center;
  color: #333333;
}
.side-screen-comments__head__subtext {
  padding-top: 3px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  display: flex;
  align-items: center;
  color: #999999;
}
.side-screen-comments__content {
  display: flex;
  padding-top: 20px;
  width: 100%;
  flex-wrap: wrap;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
  white-space: pre-line;
  word-break: break-all;
}
.side-screen-comments__content__edit {
  margin-top: 20px;
  width: 100%;
  border: none;
  resize: none;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.side-screen-comments__attachments {
  padding-top: 20px;
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0 auto;
  position: relative;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.side-screen-comments__attachments__image {
  width: 93px;
  height: 93px;
  border-radius: 8px;
  margin: 5px;
}
.side-screen-comments__attachments__images {
  position: relative;
}
.side-screen-comments__attachments__icon {
  position: absolute;
  left: 80px;
  cursor: pointer;
}
.side-screen-comments__edit-actions {
  margin-top: 20px;
  display: flex;
}
.side-screen-comments__edit-actions__cancel {
  margin-left: auto;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #999999;
  margin-right: 10px;
  cursor: pointer;
}
.side-screen-comments__edit-actions__save {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #075453;
  cursor: pointer;
}
.side-screen-comments__edit-actions__icon {
  cursor: pointer;
}

.side-screen-add-comment {
  display: flex;
  align-items: center;
  padding: 10px;
  margin: 5px 10px;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  background: #ffffff;
}
.side-screen-add-comment__input {
  flex: 1 1;
  display: flex;
  align-items: center;
  resize: none;
  border: none;
  outline: 0;
  height: 60px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
}
.side-screen-add-comment__input__icon {
  display: flex;
  width: 50px;
  height: 100%;
  align-items: center;
  justify-content: center;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #075453;
  cursor: pointer;
}
.side-screen-add-comment__input__submit {
  position: relative;
  z-index: 0;
}
.side-screen-add-comment__input__image-input {
  position: relative;
  z-index: 0;
}
.side-screen-add-comment__input__image-input__icon {
  position: absolute;
  top: 18px;
  left: 20px;
  cursor: pointer;
}

.side-screen-add-comment__input::-webkit-input-placeholder {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #c1c1c1;
}

.side-screen-add-comment__input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #c1c1c1;
}

.side-screen-add-comment__input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #c1c1c1;
}

.side-screen-add-comment__input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #c1c1c1;
}

.side-screen-add-comment__input {
  white-space: pre-line;
  word-break: break-all;
}`, "",{"version":3,"sources":["webpack://./src/components/work-a-diary/side-screen/side-screen.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AACJ;;AAEA;EACI,eAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;AACJ;;AACA;EACI,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AAEJ;;AACA;EACI,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;AAEJ;AAAI;EACI,kBAAA;EACA,QAAA;EACA,MAAA;AAER;AADQ;EACI,aAAA;EACA,eAAA;AAGZ;AACI;EACI,WAAA;EACA,kBAAA;AACR;AAEI;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;AAAR;AAOI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EAEA,iBAAA;AANR;;AAUA;EACI,iBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AARJ;AAUI;EACI,aAAA;EACA,gBAAA;AARR;AAUQ;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AARZ;AAWQ;EACI,gBAAA;EACA,iBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AATZ;AAYQ;EACI,gBAAA;EACA,iBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AAVZ;AAaQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AAXZ;AAeI;EACI,aAAA;EACA,iBAAA;EACA,gBAAA;AAbR;AAcQ;EACI,kBAAA;AAZZ;;AAiBA;EACI,aAAA;EACA,gBAAA;EACA,iBAAA;AAdJ;AAgBI;EACI,yBAAA;EACA,kBAAA;EACA,aAAA;AAdR;AAiBI;EACI,SAAA;EACA,gBAAA;AAfR;AAkBI;EACI,aAAA;AAhBR;AAkBQ;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AAhBZ;AAmBQ;EACI,SAAA;EACA,iBAAA;AAjBZ;AAoBQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AAlBZ;AAqBQ;EACI,gBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AAnBZ;AAuBI;EACI,aAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,qBAAA;AArBR;AAuBQ;EACI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAtBZ;AA0BI;EACI,iBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAzBR;AA2BQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAzBZ;AA4BQ;EACI,kBAAA;AA1BZ;AA6BQ;EACI,kBAAA;EACA,UAAA;EACA,eAAA;AA3BZ;AA+BI;EACI,gBAAA;EACA,aAAA;AA7BR;AA+BQ;EACI,iBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AA7BZ;AAgCQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AA9BZ;AAiCQ;EACI,eAAA;AA/BZ;;AAoCA;EACI,aAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAjCJ;AAmCI;EACI,SAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAjCR;AAmCQ;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAjCZ;AAoCQ;EACI,kBAAA;EACA,UAAA;AAlCZ;AAsCQ;EACI,kBAAA;EACA,UAAA;AApCZ;AAsCY;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;AApChB;;AA0CA;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAvCJ;;AAyCA;EACI,4BAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAtCJ;;AAwCA;EACI,wBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AArCJ;;AAuCA;EACI,0BAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AApCJ;;AAuCA;EACI,qBAAA;EACA,qBAAA;AApCJ","sourcesContent":[".side-screen {\n    display: flex;\n    position: fixed;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    align-items: center;\n    justify-content: center;\n    z-index: 1;\n}\n\n.side-screen-bg {\n    position: fixed;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.6);\n}\n.side-screen-content {\n    display: flex;\n    flex-direction: column;\n    margin-left: auto;\n    width: 427px;\n    height: 100%;\n    background: #fafafa;\n    position: relative;\n}\n\n.side-screen-header {\n    position: relative;\n    padding: 20px;\n    background: white;\n    max-height: 50vh;\n\n    .side-screen-action {\n        position: absolute;\n        right: 0;\n        top: 0;\n        &__close {\n            padding: 25px;\n            cursor: pointer;\n        }\n    }\n\n    &__label {\n        width: 70px;\n        text-align: center;\n    }\n\n    &__head {\n        margin-top: 15px;\n        display: flex;\n        align-items: center;\n    }\n\n    // &__pin {\n    //     cursor: pointer;\n    // }\n\n    &__text {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 22px;\n        line-height: 32px;\n        color: #333333;\n\n        margin-left: 10px;\n    }\n}\n\n.side-screen-body {\n    padding-top: 30px;\n\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #505054;\n\n    &__footer {\n        display: flex;\n        margin-top: 30px;\n\n        &__image {\n            border-radius: 50%;\n            height: 24px;\n            width: 24px;\n            object-fit: cover;\n        }\n\n        &__profile-name {\n            margin-left: 5px;\n            margin-right: 5px;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 14px;\n            line-height: 20px;\n            display: flex;\n            align-items: center;\n            color: #868686;\n        }\n\n        &__vertical {\n            margin-left: 5px;\n            margin-right: 5px;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 14px;\n            line-height: 20px;\n            display: flex;\n            align-items: center;\n            color: #e9e9e9;\n        }\n\n        &__date {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 20px;\n            display: flex;\n            align-items: center;\n            color: #999999;\n        }\n    }\n\n    .imgList {\n        display: flex;\n        flex-wrap: nowrap;\n        overflow-x: auto;\n        img {\n            border-radius: 6px;\n        }\n    }\n}\n\n.side-screen-comments {\n    padding: 20px;\n    margin-top: 15px;\n    background: white;\n\n    &__border {\n        border: 1px solid #333333;\n        border-radius: 8px;\n        padding: 15px;\n    }\n\n    &__scroll {\n        flex: 1;\n        overflow-y: auto;\n    }\n\n    &__head {\n        display: flex;\n\n        &__profileImage {\n            border-radius: 50%;\n            height: 42px;\n            width: 42px;\n            object-fit: cover;\n        }\n\n        &__head {\n            flex: 1;\n            margin-left: 15px;\n        }\n\n        &__text {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 16px;\n            line-height: 22px;\n            display: flex;\n            align-items: center;\n            color: #333333;\n        }\n\n        &__subtext {\n            padding-top: 3px;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 12px;\n            line-height: 18px;\n            display: flex;\n            align-items: center;\n            color: #999999;\n        }\n    }\n\n    &__content {\n        display: flex;\n        padding-top: 20px;\n        width: 100%;\n        flex-wrap: wrap;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n        color: #505054;\n        white-space: pre-line;\n        word-break: break-all;\n\n        &__edit {\n            margin-top: 20px;\n            width: 100%;\n            border: none;\n            resize: none;\n\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 20px;\n            color: #505054;\n        }\n    }\n\n    &__attachments {\n        padding-top: 20px;\n        display: flex;\n        flex-wrap: wrap;\n        list-style: none;\n        margin: 0 auto;\n        position: relative;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n        color: #505054;\n\n        &__image {\n            width: 93px;\n            height: 93px;\n            border-radius: 8px;\n            margin: 5px;\n        }\n\n        &__images {\n            position: relative;\n        }\n\n        &__icon {\n            position: absolute;\n            left: 80px;\n            cursor: pointer;\n        }\n    }\n\n    &__edit-actions {\n        margin-top: 20px;\n        display: flex;\n\n        &__cancel {\n            margin-left: auto;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 16px;\n            line-height: 22px;\n            color: #999999;\n            margin-right: 10px;\n            cursor: pointer;\n        }\n\n        &__save {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 16px;\n            line-height: 22px;\n            color: #075453;\n            cursor: pointer;\n        }\n\n        &__icon {\n            cursor: pointer;\n        }\n    }\n}\n\n.side-screen-add-comment {\n    display: flex;\n    align-items: center;\n    padding: 10px;\n    margin: 5px 10px;\n    border: 1px solid #e9e9e9;\n    border-radius: 8px;\n    background: #ffffff;\n\n    &__input {\n        flex: 1;\n        display: flex;\n        align-items: center;\n        resize: none;\n        border: none;\n        outline: 0;\n        height: 60px;   \n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 16px;\n        color: #333333;\n\n        &__icon {\n            display: flex;\n            width: 50px;\n            height: 100%;\n            align-items: center;\n            justify-content: center;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 16px;\n            line-height: 22px;\n            color: #075453;\n            cursor: pointer;\n        }\n\n        &__submit {\n            position: relative;\n            z-index: 0;\n\n        }\n\n        &__image-input {\n            position: relative;\n            z-index: 0;\n\n            &__icon {\n                position: absolute;\n                top: 18px;\n                left: 20px;\n                cursor: pointer;\n            }\n        }\n    }\n}\n\n.side-screen-add-comment__input::-webkit-input-placeholder {\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    color: #c1c1c1;\n}\n.side-screen-add-comment__input:-moz-placeholder {\n    /* Mozilla Firefox 4 to 18 */\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    color: #c1c1c1;\n}\n.side-screen-add-comment__input::-moz-placeholder {\n    /* Mozilla Firefox 19+ */\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    color: #c1c1c1;\n}\n.side-screen-add-comment__input:-ms-input-placeholder {\n    /* Internet Explorer 10+ */\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    color: #c1c1c1;\n}\n\n.side-screen-add-comment__input {\n    white-space: pre-line;\n    word-break: break-all;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
